module.exports = __webpack_public_path__ + "img/logo-s2grupo.c1f767e.png";